<template>
  <generic-modal
    size="large"
    :title="$t('collegiate specialty configuration')"
    icon="settings"
    image="/images/icons/document.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :show_ok="false"
    :show_cancel="false"
  >
    <div class="description">
      <specialty-types />
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import SpecialtyTypes from "./SpecialtyTypes";

export default {
  components: {
    "generic-modal": GenericModal,
    SpecialtyTypes,
  },
  computed: {},
  data() {
    return {
      types: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
